import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Typography, Modal, Icon } from '@safedns/skydns-ui-react-lib';

import {
  useGetUserQuery,
  useDeleteUserWithProfileMutation,
} from '../../services/ADapi';

import { notificationSuccess } from '../../store/notificationReducer';

import sprite from '../../icons/sprite.svg';
import styles from '../../styles/deleteModal.module.scss';

const DeleteADAgentModal = ({ id, agentName, onClose }) => {
  const dispatch = useDispatch();
  const {
    data: { user_id },
  } = useGetUserQuery();
  const [deleteUserWithProfile] = useDeleteUserWithProfileMutation();

  const [isDisabled, setDisabledState] = useState(false);

  const deleteAgentModal = async () => {
    setDisabledState(true);

    try {
      await deleteUserWithProfile({ user_id, adUserId: id }).unwrap();
    } catch (error) {
      console.error('Error deleting user with profile:', error);
      setDisabledState(false);
    }

    dispatch(
      notificationSuccess({
        isNotification: true,
        type: 'success',
        message: `${agentName} успешно удален`,
      })
    );

    onClose();
  };

  return (
    <Modal
      isOpen={true}
      title="Удалить AD агент?"
      onClose={onClose}
      sx={{ maxWidth: 400 }}
    >
      <div className={styles['modal-content']}>
        <div className={styles['icon-wrapper']}>
          <Icon
            id="remove"
            sprite={sprite}
            width={24}
            height={24}
            color="white"
          />
        </div>
        <Typography
          sx={{
            paddingTop: 12,
            paddingBottom: 24,
            textAlign: 'center',
            fontWeight: 500,
          }}
        >
          Вы уверены что хотите удалить <br /> {agentName}?
        </Typography>
        <div className="button-grid">
          <Button variant="secondary" onClick={onClose} size="small">
            Отмена
          </Button>
          <Button
            variant="primary"
            size="small"
            isDisabled={isDisabled}
            onClick={deleteAgentModal}
          >
            Удалить
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteADAgentModal;
